import React from 'react'
import '../App.css';

const Footer = () => {
  return (
    <div className="footer-container">
      <p className="rights">2024 All rights reserved.</p>
    </div>
  );
}

export default Footer;